module.exports = __webpack_public_path__ + "img/TechtreeBG5.0c1f77fa.webp";